import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { mkConfig, generateCsv, download } from "export-to-csv";

import RevyzLogo from "../assets/revyz-logo-svg.png";

import { createDownloadFileName } from "./helpers";

export const defaultFormatter = (rows) => rows;

/**
 *
 * @param {string} title
 * @param {[]} columnHeaders
 * @param {[]} rows
 * @param {function} rowsFormatter
 * @param {string} fileNameWithoutDate
 * @param {boolean} showTitle
 * @param {boolean} showColumnHeaders
 * @param {boolean} useKeysAsHeaders
 */
export const handleCSVExport = (
  title,
  columnHeaders,
  rows,
  fileNameWithoutDate = "download",
  rowsFormatter = defaultFormatter,
  showTitle = false,
  showColumnHeaders = true,
  useKeysAsHeaders = false
) => {
  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: useKeysAsHeaders,
    filename: createDownloadFileName(fileNameWithoutDate),
    title: title,
    showTitle: showTitle,
    showColumnHeaders: showColumnHeaders,
    columnHeaders: columnHeaders,
    boolDisplay: { true: "Yes", false: "No" },
  });

  const rowData = rowsFormatter(rows);
  const csv = generateCsv(csvConfig)(rowData);
  download(csvConfig)(csv);
};

/**
 *
 * @param {string} title - "Jira configurations"
 * @param {Object} pdfConfig - https://www.npmjs.com/package/jspdf
 * @returns
 */
const getPDFDocumentConfiguration = (title, pdfConfig) => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a1",
    putOnlyUsedFonts: true,
    floatPrecision: 16, // or "smart", default is 16
    ...pdfConfig,
  });
  doc.setFontSize(16);
  doc.addImage(RevyzLogo, "PNG", 12, 12, 60, 18);
  doc.text(title, 110, 20);
  doc.setFontSize(14);

  return doc;
};

/**
 *
 * @param {[]} header
 * @param {[]} rows
 * @param {Object} config - https://www.npmjs.com/package/jspdf-autotable
 * @returns
 */
const getPDFTableConfig = (header, rows, config) => {
  return {
    head: header,
    body: rows,
    headStyles: {
      overflow: "linebreak",
      minCellWidth: 22,
    },
    styles: {},
    columnStyles: {
      cellWidth: "wrap",
      minCellWidth: 22,
    },
    margin: { top: 40 },
    ...config,
  };
};

/*
export const getTableFormmater = (
  header,
  rows,
  headerFomatter = defaultFormatter,
  rowsFormatter = defaultFormatter
) => {
  return {
    header: headerFomatter(header),
    rows: rowsFormatter(rows),
  };
};
*/

export const handlePDFExport = (
  title,
  tables,
  fileNameWithoutDate,
  pdfConfig,
  tableConfig
) => {
  const doc = getPDFDocumentConfiguration(title, pdfConfig);

  for (const inputTable of tables) {
    const table = getPDFTableConfig(
      inputTable.header,
      inputTable.rows,
      tableConfig
    );
    autoTable(doc, table);
  }

  const pdfFileName = `${createDownloadFileName(fileNameWithoutDate)}.pdf`;
  doc.save(pdfFileName);
  return doc;
};
